    export const savings =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627803/mad_wallet/images/features/revenue.png";
    export const savingsMsgMb = 
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1653910191/mad_wallet/images/features/Resp-Defi-Savings-panel.png";
    export const savingsMsg = 
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1653909547/mad_wallet/images/features/Defi-Savings-panel.png";
  
  export const crosschain =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627802/mad_wallet/images/features/crosschain.png";
  export const crosschainMsgMb =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1653910191/mad_wallet/images/features/Resp-Cross-chain-Bridge-panel.png";
  export const crosschainMsg =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1653909547/mad_wallet/images/features/Cross-chain-bridge-panel.png";
  
  export const marketplace =
      "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627803/mad_wallet/images/features/xwallet.png";
  export const marketplaceMsgMb =
      "https://res.cloudinary.com/dahddvlgy/image/upload/v1653910191/mad_wallet/images/features/Resp-NFT-Marketplace-panel.png";
  export const marketplaceMsg =
      "https://res.cloudinary.com/dahddvlgy/image/upload/v1653909547/mad_wallet/images/features/NFT-Marketplace-panel.png";
    
  export const customization =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627803/mad_wallet/images/features/reward.png";
  export const customizationMsgMb =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1653910191/mad_wallet/images/features/Resp-Customization-panel.png";
  export const customizationMsg =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1653909547/mad_wallet/images/features/Customization-panel.png";
  
  export const FeaturesBg =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1650285716/mad_wallet/images/features/mdw__features.jpg";

  export const featuresMobileNav =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1652314200/mad_wallet/images/features/features-header.png";
  
  
    export const tabs = [
      {
        name: "savings",
        label: "DeFi Savings",
      },
      {
        name: "cross-chain",
        label: "CROSS-CHAiN BRiDGE",
      },
      {
        name: "market",
        label: "NFT Marketplace",
      },
      {
        name: "customization",
        label: "customization",
      },
    ];

    